import React from 'react';
import { ChooseSourceRadioButton } from 'components/common/override-rates/ChooseSourceRadioButton';
import { observer } from 'mobx-react-lite';
import { useOverrideUwRatesPageStore } from 'store/pages/override-uw-rates/pageStore';
import { BarStyled } from './styles';
import { CHOOSE_QUOTES_BAR_TEST_IDS } from '../constants';

export const ChooseQuotesBar: React.FC = observer(() => {
  const {
    uwRatesOverriderDelegate: { selectedRateSource, setRateSource, cannotSelectFinalRates },
  } = useOverrideUwRatesPageStore();

  return (
    <BarStyled>
      <ChooseSourceRadioButton
        id="quoteSource"
        label="Based on Quoted Rates"
        checked={selectedRateSource === 'original'}
        onChange={() => setRateSource('original')}
        data-test-id={CHOOSE_QUOTES_BAR_TEST_IDS.QUOTE_SOURCE_RADIO}
      />
      <ChooseSourceRadioButton
        id="finalSource"
        label="Based on Final Rates"
        checked={selectedRateSource === 'final'}
        onChange={() => setRateSource('final')}
        disabled={cannotSelectFinalRates}
        data-test-id={CHOOSE_QUOTES_BAR_TEST_IDS.FINAL_SOURCE_RADIO}
      />
    </BarStyled>
  );
});
